import React, { useState } from "react";
// import { design, T } from "../../../utils/theme";
// import KDSService from "../../../services/OrderingServices/KDSService";
import toast from "react-hot-toast";
import KDSService from "../../../services/OrderingServices/KDSService";
import { design, T } from "../../../utils/theme";

export default function ItemWiseView({ orders, fetchOrderList }) {
  const [loadingId, setLoadingId] = useState(null);

  // ─── FLATTEN ITEMS FIRST ───
  const flatItems = orders.flatMap((order) =>
    order.items.map((item) => ({
      ...item,
      table: order.table,
      orderId: order.orderId,
    })),
  );

  // ─── GROUP BY PRODUCT NAME ───
  const groupedByProduct = flatItems.reduce((acc, item) => {
    const key = item.productName;

    if (!acc[key]) {
      acc[key] = {
        productName: item.productName,
        items: [],
      };
    }

    acc[key].items.push(item);
    return acc;
  }, {});

  // ─── TOTALS ───
  Object.values(groupedByProduct).forEach((product) => {
    product.totalPending = product.items.filter((i) => !i.preparedAt).length;
    product.totalPrepared = product.items.filter(
      (i) => i.preparedAt && !i.servedAt,
    ).length;
    product.totalServed = product.items.filter((i) => i.servedAt).length;

    product.totalQuantity = product.items.reduce(
      (sum, i) => sum + i.quantity,
      0,
    );
  });

  // ─── ACTION HANDLER ───
  const handlePrepareOrServe = async (itemId, productName) => {
    try {
      setLoadingId(itemId);

      const item = flatItems.find((i) => i.orderDetailId === itemId);
      if (!item) return;

      if (!item.preparedAt) {
        await KDSService.markPrepare(itemId);
        toast.success(`${productName} prepared`);
      } else if (!item.servedAt) {
        await KDSService.markServe(itemId);
        toast.success(`${productName} served`);
      }

      await fetchOrderList();
    } catch (err) {
      toast.error(err.message || "Update failed");
    } finally {
      setLoadingId(null);
    }
  };

  return (
    <div style={{ padding: design.spacing.lg }}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
          gap: design.spacing.md,
        }}
      >
        {Object.values(groupedByProduct).map((product) => (
          <div
            key={product.productName}
           style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.08), 0 8px 24px rgba(0,0,0,0.12)", borderRadius: 12, overflow: "hidden" }}
          >
            {/* HEADER */}
            <div
              style={{
                position: "sticky",
                top: 0,
                zIndex: 2,
                background: T.surfaceAlt,
                padding: "8px 10px",
                borderBottom: `1px solid ${T.border}`,
              }}
            >
              <div className="d-flex justify-content-between align-items-center">
                <div style={{ fontWeight: 700, fontSize: "14px" }}>
                  {product.productName}
                </div>

                <div
                  style={{ fontSize: "14px", fontWeight: 700, color: T.orange }}
                >
                  ×{product.totalQuantity}
                </div>
              </div>

              <div
                style={{
                  fontSize: "11px",
                  display: "flex",
                  gap: 10,
                  marginTop: 4,
                }}
              >
                <span style={{ color: T.orange }}>
                  {product.totalPending} P
                </span>
                <span style={{ color: T.yellow }}>
                  {product.totalPrepared} R
                </span>
                <span style={{ color: T.green }}>{product.totalServed} S</span>
              </div>
            </div>

            {/* ITEMS */}
            {/* <div style={{ overflowY: "auto", flex: 1 }}> */}
            <div
  style={{
    maxHeight: "25vh",
    overflowY: "auto",
    scrollbarWidth: "thin",
    // scrollbarColor: "#888 #f1f1f1"
    scrollbarColor: `${T.border} transparent`,
  }}
>
              {product.items.map((item) => {
                const isPrepared = !!item.preparedAt;
                const isServed = !!item.servedAt;
                const isLoading = loadingId === item.orderDetailId;

                return (
                  <div
                    key={item.orderDetailId}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 6,
                      padding: "6px 8px",
                      fontSize: "12px",
                      borderBottom: `1px solid ${T.border}`,
                      background: isServed
                        ? T.greenLight
                        : isPrepared
                        ? `${T.yellow}22`
                        : "transparent",
                    }}
                  >
                    {/* ORDER ID */}
                    <div
                      style={{
                        fontFamily: "monospace",
                        fontSize: "11px",
                        width: 110,
                        color: T.textMuted,
                      }}
                    >
                      {item.orderId}
                    </div>

                    {/* TABLE */}
                    <div
                      style={{
                        fontSize: "11px",
                        width: 90,
                        color: T.textSecond,
                      }}
                    >
                      {item.table}
                    </div>

                    {/* QTY */}
                    <div
                      style={{
                        fontWeight: 700,
                        width: 30,
                        textAlign: "right",
                        color: T.orange,
                      }}
                    >
                      ×{item.quantity}
                    </div>

                    {/* ACTION */}
                    {!isServed ? (
                      <button
                        onClick={() =>
                          handlePrepareOrServe(
                            item.orderDetailId,
                            product.productName,
                          )
                        }
                        disabled={isLoading}
                        style={{
                          marginLeft: "auto",
                          fontSize: "11px",
                          padding: "3px 6px",
                          borderRadius: 4,
                          border: "none",
                          background: isPrepared ? T.green : T.orange,
                          color: "#fff",
                          fontWeight: 600,
                          cursor: "pointer",
                          opacity: isLoading ? 0.6 : 1,
                        }}
                      >
                        {isLoading ? "..." : isPrepared ? "Serve" : "Prep"}
                      </button>
                    ) : (
                     <i className="ri-checkbox-circle-fill mx-auto" style={{ fontSize: "16px", color: T.green }} />
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>

      {/* EMPTY STATE */}
      {Object.keys(groupedByProduct).length === 0 && (
        <div style={{ textAlign: "center", padding: 40 }}>
          <div style={{ fontSize: 32 }}>✨</div>
          <div style={{ fontSize: 14 }}>All caught up</div>
        </div>
      )}
    </div>
  );
}
